import { StrictMode, startTransition } from 'react'

import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import i18next from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import { version } from 'package.json'
import { hydrateRoot } from 'react-dom/client'
import { I18nextProvider, initReactI18next } from 'react-i18next'
import { HydratedRouter } from 'react-router/dom'
import { getInitialNamespaces } from 'remix-i18next/client'
import { v4 as uuidv4 } from 'uuid'

import { i18nconfig } from './i18n'
import { Environment } from './types/app'

if (window['ENV']?.bugsnagApiKey && window['ENV']?.env !== Environment.LOCAL) {
  Bugsnag.start({
    apiKey: window['ENV']?.bugsnagApiKey,
    plugins: [new BugsnagPluginReact()],
    appVersion: version,
    appType: 'spa',
    releaseStage: window['ENV']?.env,
    onError: (event) => {
      const errorId = uuidv4().split('-')[0]
    
      event.addMetadata('error', {
        id: errorId,
      })
    
      event.groupingHash = event.errors[0].errorMessage
    }
  })
}

// eslint-disable-next-line import/no-named-as-default-member
i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(Backend)
  .init({
    ...i18nconfig(),
    ns: getInitialNamespaces(),
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    detection: {
      order: ['htmlTag'],
      caches: [],
    },
    react: {
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'em', 'p', 'ol', 'ul', 'li', 'a'],
    }
  })
  .then(() => startTransition(() => {
    hydrateRoot(document,
      <StrictMode>
        <I18nextProvider i18n={i18next}>
          <HydratedRouter />
        </I18nextProvider>
      </StrictMode>
    )
  })
  )